module.exports = __webpack_public_path__ + "assets/images/pages/ministerioconsumo/grid-8.png?7ea65cf4";